/* eslint key-spacing: 'off', comma-spacing: 'off' */
import current from '@/scripts/current'
import store from '@/store';

export default {
  getHelpState: function (selectionModel) {
    var singleYearSelected = store.state.selModel.years.selectionType == 'single' && store.state.selModel.years.single > 0;
    var combiningYears = store.state.selModel.years.selectionType === 'combine' && store.state.selModel.years.values.length >= 2;
    var comparingYears = store.state.selModel.years.selectionType === 'compare' && store.state.selModel.years.values.length >= 2;
    const locations = store.state.selModel.locations;
    var singleLocationSelected = locations.selectionType === 'single' && locations.allIds.length === 1;
    var combiningLocations = locations.selectionType === 'combine' && locations.allIds.length >= 2;
    var comparingLocations = locations.selectionType === 'compare' && locations.allIds.length >= 2;

    var dependentIsYear = current.selectionModel.v.dependent.type === 'year';
    var anyIndependentIsYear = current.selectionModel.v.independent.filter(v => v.type === 'year').length > 0;
    var anyIndependentIsLocation = current.selectionModel.v.independent.filter(v => v.type === 'location').length > 0;
    var dependentIsLocation = current.selectionModel.v.dependent.type === 'location';

    var state = {
      step: current.selectionModel.currentStep,
      singleYearSelected: singleYearSelected,
      combiningYears: combiningYears,
      comparingYears: comparingYears,
      justSelectedYear: singleYearSelected || combiningYears || comparingYears,
      hasYearBeenAssigned: dependentIsYear || anyIndependentIsYear,
      singleLocationSelected: singleLocationSelected,
      combiningLocations: combiningLocations,
      comparingLocations: comparingLocations,
      justSelectedLocation: singleLocationSelected || combiningLocations || comparingLocations,
      hasLocationBeenAssigned: dependentIsLocation || anyIndependentIsLocation,
      isDependentSelected: current.selectionModel.v.dependent.isSelected(),
      dependentIsYear: dependentIsYear,
      anyIndependentIsYear: anyIndependentIsYear,
      dependentIsLocation: dependentIsLocation,
      anyIndependentIsLocation: anyIndependentIsLocation,
      anyIndependentSelected: current.selectionModel.v.independent.length > 0
    };

    return state;
  }
}
